module.exports = __webpack_public_path__ + "static/media/26UNRWA21.4c3a3120.jpg";